export const displayBannerPositions = ['FEED_0', 'FEED_1', 'MOBILE', 'BRAND_TILE'];
export const refreshBannerPositions = ['FEED_0', 'FEED_1'];

export const displayCookies = {
  ADOBE_IDENTIFIER: 'aam_uuid',
  RSI_SEGMENTS: 'rsi_segs',
};

export const bannerPositionsInFeeds = {
  FEED_0: {
    key: 'home_top',
    isCalled: false,
  },
  MOBILE: {
    key: 'home_top',
    isCalled: false,
  },
  FEED_1: {
    key: 'home_right',
    isCalled: false,
  },
  BRAND_TILE: {
    key: 'home_brandtile',
    isCalled: false,
  },
};

export const bannerTargetsInFeeds = {
  FEED_0: 'banner-top-dt',
  MOBILE: 'banner-top-dt',
  FEED_1: 'banner-right',
  BRAND_TILE: 'premium-content-brandtile-dt',
};

export const heightForBannerPositionInFeeds = 780;
export const FEED_BANNER_CREATIVE = { width: 970, height: 250 };

export const bannerItemPositionsInFeeds = {
  WITH_DOUBLE_TILE_MP_CARD: 8,
  WITH_SINGLE_TILE_MP_CARD: 9,
  IN_LONG_SCREEN: 10,
  IN_SHORT_SCREEN: 5,
};

// Shifted positions when brand tile is enabled (brand tile takes a slot at position 4)
export const bannerItemPositionsInFeedsWithBrandTile = {
  WITH_DOUBLE_TILE_MP_CARD: 7,
  WITH_SINGLE_TILE_MP_CARD: 8,
  IN_LONG_SCREEN: 9,
  IN_SHORT_SCREEN: 4,
};

export const minViewPortSizeForBannersInFeeds = 1320;

// Brand tile position constants
export const BRAND_TILE_FEED_POSITION = 3; // 4th item (0-indexed)
export const BRAND_TILE_REPEAT_INTERVAL = 40; // Repeats every 40 items (positions 4, 44, 84, etc.)
